import "./index.css";
import { notification } from "antd";
import { useSelector } from "react-redux";
import React, { useCallback, useEffect, useRef } from "react";

notification.config({
  bottom: 12,
});

export function useGetLenders(
  isMobile: boolean,
  profile: Record<string, string>,
) {
  const timer = useRef<NodeJS.Timeout>();
  const refProfile = useRef(profile);

  useEffect(() => {
    refProfile.current = profile;
  }, [profile]);

  const common = useSelector((state: any) => state.common);
  const showPdf = common.showPdf;

  const USER_ID = profile?.ID;

  /**
   * @name showCloseIcon 是否显示 “关闭图标”
   * @description 只有登陆了才能关闭，notification.info一旦生成就不是响应式的，所以就只能通过ref单独控制
   *
   */
  const showCloseIcon = () => {
    setTimeout(() => {
      const ele = document.getElementsByClassName("hint-notif-lenders")?.[0]
        ?.children?.[1] as HTMLAnchorElement;
      if (ele) {
        ele.style.display = refProfile.current?.ID ? "block" : "none";
      }
    });
  };

  function isGuidelineGPT() {
    const { pathname } = window.location;
    return (
      !pathname.includes("/workflow") && pathname.includes("/guidelinegpt")
    );
  }

  useEffect(() => {
    timer.current = setTimeout(() => {
      clearTimeout(timer.current);
      const ID = refProfile.current?.ID;
      const ele = document.getElementsByClassName("hint-notif-lenders")?.[0];
      // 用户是否自行关闭（过渡方案）
      const USER_CLOSED = ID
        ? localStorage.getItem(`notif_lenders_${ID}`) === "true"
        : false;
      if (
        common.showPdf &&
        !ele &&
        !isMobile &&
        isGuidelineGPT() &&
        !USER_CLOSED
      ) {
        notification.info({
          duration: 0,
          key: "notif-lenders",
          placement: "bottomRight",
          description: <GetLendersBanner />,
          message: <img src="/programs.png" height={123} />,
          className: "hint-notif hint-notif-lenders", // 这里会通过 “hint-notif-lenders” 进行唯一交互
          onClose() {
            localStorage.setItem(`notif_lenders_${ID}`, "true");
          },
        });
        showCloseIcon();
      }
    }, 3000);
  }, [showPdf]);

  useEffect(() => {
    showCloseIcon();
    USER_ID &&
      localStorage.getItem(`notif_lenders_${USER_ID}`) === "true" &&
      notification.destroy("notif-lenders");
  }, [USER_ID]);

  useEffect(() => {
    const ele = document.getElementsByClassName(
      "hint-notif-lenders",
    )?.[0] as HTMLDivElement;
    if (!ele) return;
    ele.style.setProperty("display", "block");
    (isMobile || !showPdf) && ele.style.setProperty("display", "none");
    return () => {
      clearTimeout(timer.current);
      ele.style.setProperty("display", "none");
    };
  }, [isMobile, showPdf]);
}

const GetLendersBanner: React.FC = () => {
  const handleContactClick = useCallback(() => {
    window.open("https://www.zeitro.com/demo", "_blank");
  }, []);

  function onLearnMore() {
    window.open("https://www.zeitro.com/scenario-ai-lender", "_blank");
  }

  return (
    <div className="get-lenders-ctx">
      <div>
        <p>Can't find the right programs?</p>
        <p>Contact us to add lenders and tailor programs to your workflow.</p>
      </div>
      <button onClick={handleContactClick} className="get-lenders-btn-primary">
        Contact us
      </button>
      <button onClick={onLearnMore} className="get-lenders-btn-ghost">
        Learn more
      </button>
    </div>
  );
};

export default GetLendersBanner;
